// const dealSlider = new Swiper(".deal-slider", {
//   loop: true,               // Infinite loop
//   autoplay: {               // Auto-play
//     delay: 2500,
//   },
//   pagination: {             // Dots at bottom
//     el: ".swiper-pagination",
//     clickable: true,
//   }
// });


// const cstmImgSlider = new Swiper(".cstm-img-slider", {
//   loop: true,
//   slidesPerView: 2,
//   spaceBetween: 30,
// });


// const brandSlide = new Swiper(".brand-slider", {
//   loop: true,
//   slidesPerView: 3,
//   spaceBetween: 30,
// });

// const multipleDealSlider = new Swiper(".multiple-deal-slider", {
//   loop: true,
//   slidesPerView: 3,
//   spaceBetween: 30,
// });
// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
      intro.onclick = (e) => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(e.target.closest('[js-acc-item]'));
        }
      };
    }
  });   
}

(function() {
  faq_taggol();  
  (document.querySelector("[data-header-tans]") || null) && document.body.classList.add("header-transparent");
})();





//faq section
const faq_main_wap = document.querySelector('[faq_main_wap]') || null;
if (faq_main_wap) {
  const faq_toggles = faq_main_wap.querySelectorAll('[data-act-title]') || null;
  const faq_content_wap = faq_main_wap.querySelector('[faq_content_wap]') || null;
  const faq_content_tabs = faq_content_wap.querySelectorAll('.tabs') || null;
  const faq_dropdown = faq_main_wap.querySelector('.faq-category-dropdown') || null;
  const faq_selected = faq_main_wap.querySelector('.faq-category-selected') || null;
  const mian_tag = document.querySelector('.faq-category')|| null;
  const content = document.querySelector("[js-acc-single-content]");
  
  if (faq_content_wap) {
    faq_toggles.forEach((faq) => {
      faq.addEventListener('click', (event) => {
        faq_content_tabs.forEach((tab) => {
          tab.classList.remove('active');
          tab.style.display = 'none';
        });

        faq_toggles.forEach((toggle) => {
          toggle.classList.remove('active-tab');
        });

        const targetSelector = event.currentTarget.getAttribute('data-act-title');
        const targetTab = faq_content_wap.querySelector(targetSelector);

        if (targetTab) {
          targetTab.classList.add('active');
          targetTab.style.display = 'block';
          
         
        }
        event.currentTarget.classList.add('active-tab');
        

        if (faq_dropdown && faq_selected) {
          faq_selected.textContent = event.currentTarget.textContent.trim();
          faq_dropdown.classList.remove('open'); // Adjust class based on your dropdown open state
          mian_tag.classList.remove('active');
          if(content){
            content.style.maxHeight = null;
          }
        }
      });
    });

    if (faq_dropdown) {
      faq_dropdown.addEventListener('click', () => {
        faq_dropdown.classList.toggle('open'); // Add/remove "open" class for the dropdown
      });
    }
  }
}
//faq section end



(function() {
  function setupHoverPopup(triggerSelector, popupId) {
      const trigger = document.querySelector(triggerSelector);
      const popup = document.getElementById(popupId);
      if (!trigger || !popup) return;

      let hideTimer;

      function show() {
        clearTimeout(hideTimer);
        popup.style.display = popupId === 'discover-popup' ? 'block' : 'block';
        popup.style.animation = 'none';
        popup.offsetHeight; // reflow to restart animation
        popup.style.animation = '';
      }

      function hide() {
        hideTimer = setTimeout(() => { popup.style.display = 'none'; }, 150);
      }

      trigger.addEventListener('mouseenter', show);
      trigger.addEventListener('mouseleave', hide);
      popup.addEventListener('mouseenter', show);
      popup.addEventListener('mouseleave', hide);
    }

    // Init both popups
    setupHoverPopup('.icon_categories', 'categories-popup');
    setupHoverPopup('.icon_discover', 'discover-popup');

})();









// Tabs js code here  
const tabs = document.querySelectorAll('[data-tab-target]')
const tabContents = document.querySelectorAll('[data-tab-content]')

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = document.querySelector(tab.dataset.tabTarget)
      tabContents.forEach(tabContent => {
        tabContent.classList.remove('active')
      })
      tabs.forEach(tab => {
        tab.classList.remove('active')
      })
      tab.classList.add('active')
      target.classList.add('active')
    })
  })
// Swiper Slider js code here





